import type { Component, Entity2D } from '../../odie';

import { FossilBlockProps, CountBlockOptionDef } from '../defs/block';
import { FossilBlockView } from '../views/blocks/FossilBlockView';

export type FossilBlockComponentOptions = {
  props: FossilBlockProps;
  option?: number;
};

export class FossilBlockComponent implements Component {
  public static readonly NAME = 'blockFossil';

  public entity!: Entity2D;
  public view!: FossilBlockView;
  private props!: FossilBlockProps;

  public init(args: FossilBlockComponentOptions): void {
    // get option def
    const optionDef = args.props.options?.[
      args.option || 0
    ] as CountBlockOptionDef;

    this.props = args.props;

    // create view
    this.view = new FossilBlockView(args.props);

    // set initial count
    this.count = optionDef.count;

    // Set the getGameplayState retrieval function
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  public getGameplayState(): number {
    const options = this.props.options as CountBlockOptionDef[];
    return options.findIndex((opt) => {
      return opt.count === this.view.count;
    });
  }

  public get count(): number {
    return this.view.count;
  }

  public set count(value: number) {
    this.view.count = value;
  }
}
